import React, { useState } from "react"
import { Modal } from "../Modal/Modal"
import ProjectDetails from "../ProjectDetails"

const Card = ({ heading, paragraph, imgUrl, projectLink, technology }) => {
  const [open, setopen] = useState(false)
  
  // Safely convert technology prop to an array whether it comes as a string or an array
  const techStack = typeof technology === "string" 
    ? technology.split(",").map(tech => tech.trim()) 
    : technology || [];

  return (
    <div
      className="card"
      style={{
        backgroundImage:
          "linear-gradient(to bottom, rgba(245, 246, 252, 0), rgba(0, 0, 0, 0.8)),url(" +
          imgUrl +
          ")",
      }}
    >
      {/* Hover Content Block (Heading, Paragraph, and Button hide/show here) */}
      <div className="content">
        <h1 className="header">{heading}</h1>
        <p className="text">{paragraph}</p>
        
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="btn"
          onClick={() => setopen(true)}
        >
          Explore
        </a>
      </div>

      {/* Static Tech Stack Footer (Always visible at the bottom of the card) */}
      {techStack.length > 0 && (
        <div className="static-tech-container">
          {techStack.map((tech, index) => (
            <span key={index} className="static-badge">
              {tech}
            </span>
          ))}
        </div>
      )}

      <Modal show={open} handleClose={() => setopen(false)}>
        <ProjectDetails
          heading={heading}
          imgUrl={imgUrl}
          paragraph={paragraph}
          projectLink={projectLink}
          technology={technology}
        />
      </Modal>
    </div>
  )
}

export default Card